/**
  Autogenerated file. Do not edit manually.
  @openapi https://search-bff.envdevel.com/v3/api-docs
*/


export type ListStyle = typeof ListStyle[keyof typeof ListStyle];


export const ListStyle = {
  BULLET: 'BULLET',
  DIAMOND: 'DIAMOND',
} as const;
